"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdatePasswordLayout = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const button_1 = require("../../../../component/input/button");
const material_1 = require("@mui/material");
const password_field_1 = require("../../../../component/input/password-field");
const formik_1 = require("formik");
const user_1 = require("../../../../network/user");
const use_lazy_promise_1 = require("../../../../hook/use-lazy-promise");
const alert_context_1 = require("../../../../context/alert-context");
exports.UpdatePasswordLayout = (0, react_1.memo)(() => {
    const [open, setOpen] = (0, react_1.useState)(false);
    const { showAlert } = (0, alert_context_1.useAlert)();
    const { status, error, execute } = (0, use_lazy_promise_1.useLazyPromise)(user_1.updatePassword);
    const formik = (0, formik_1.useFormik)({
        initialValues: {
            currentPassword: "",
            newPassword: "",
            confirmNewPassword: "",
        },
        validateOnChange: false,
        validateOnBlur: false,
        validate: (values) => {
            const errors = {};
            if (values.currentPassword.length === 0) {
                errors.currentPassword = "Current password is required";
                return errors;
            }
            if (values.newPassword.length < 6) {
                errors.newPassword = "New password must be at least 6 characters";
                return errors;
            }
            if (values.newPassword !== values.confirmNewPassword) {
                errors.confirmNewPassword = "Passwords do not match";
                return errors;
            }
        },
        onSubmit: (values) => {
            handleUpdatePassword(values.currentPassword, values.newPassword);
        },
    });
    const handleOpenDialog = (0, react_1.useCallback)(() => {
        setOpen(true);
    }, []);
    const handleCloseDialog = (0, react_1.useCallback)(() => {
        setOpen(false);
    }, []);
    const handleUpdatePassword = (0, react_1.useCallback)((currentPassword, newPassword) => {
        execute(currentPassword, newPassword);
    }, [execute]);
    (0, react_1.useEffect)(() => {
        if (status === use_lazy_promise_1.FetchStatus.Success) {
            showAlert("Password updated successfully", alert_context_1.AlertType.Success);
            formik.resetForm();
            handleCloseDialog();
        }
    }, [status, showAlert, formik, handleCloseDialog]);
    return ((0, jsx_runtime_1.jsxs)(material_1.Stack, { direction: "row", alignItems: "center", width: "100%", justifyContent: "flex-end", children: [(0, jsx_runtime_1.jsx)(button_1.Button, { variant: "contained", onClick: handleOpenDialog, children: "Update Password" }), (0, jsx_runtime_1.jsxs)(material_1.Dialog, { fullWidth: true, open: open, onClose: handleCloseDialog, children: [(0, jsx_runtime_1.jsx)(material_1.DialogTitle, { children: "Update Password" }), (0, jsx_runtime_1.jsx)(material_1.DialogContent, { children: (0, jsx_runtime_1.jsxs)(material_1.Stack, { direction: "column", spacing: 2, marginTop: 1, children: [(0, jsx_runtime_1.jsx)(password_field_1.PasswordField, { label: "Current Password", fullWidth: true, name: "currentPassword", value: formik.values.currentPassword, onChange: formik.handleChange, error: !!formik.errors.currentPassword, helperText: formik.errors.currentPassword }), (0, jsx_runtime_1.jsx)(password_field_1.PasswordField, { label: "New Password", fullWidth: true, name: "newPassword", value: formik.values.newPassword, onChange: formik.handleChange, error: !!formik.errors.newPassword, helperText: formik.errors.newPassword }), (0, jsx_runtime_1.jsx)(password_field_1.PasswordField, { label: "Confirm New Password", fullWidth: true, name: "confirmNewPassword", value: formik.values.confirmNewPassword, onChange: formik.handleChange, error: !!formik.errors.confirmNewPassword, helperText: formik.errors.confirmNewPassword }), status === use_lazy_promise_1.FetchStatus.Error && ((0, jsx_runtime_1.jsx)(material_1.Typography, { color: "error", variant: "body2", children: (error === null || error === void 0 ? void 0 : error.message) || "Failed to update password" }))] }) }), (0, jsx_runtime_1.jsx)(material_1.DialogActions, { children: (0, jsx_runtime_1.jsxs)(material_1.Stack, { direction: "row", alignItems: "center", justifyContent: "space-between", padding: 2, spacing: 2, children: [(0, jsx_runtime_1.jsx)(button_1.Button, { onClick: handleCloseDialog, children: "Cancel" }), (0, jsx_runtime_1.jsx)(button_1.Button, { variant: "contained", onClick: formik.submitForm, disabled: status === use_lazy_promise_1.FetchStatus.Loading, children: "Update" })] }) })] })] }));
});
exports.UpdatePasswordLayout.displayName = "UpdateNicknameLayout";
